import { Module } from 'vuex'
import { RootState } from '@/store'
import { User } from '@/interfaces/UserInterfaces'

export interface UserState {
  isAuthenticated: boolean;
  isImpersonated: boolean;
  user: User | null
}

const user: Module<UserState, RootState> = {
  namespaced: true,

  state: {
    isAuthenticated: !!localStorage.getItem('onesource__token') || false,
    isImpersonated: false,
    user: null
  },

  getters: {
    isAuthenticated (state: UserState): boolean {
      return state.isAuthenticated
    },
    isImpersonated (state: UserState): boolean {
      return state.isImpersonated
    },
    currentUser (state: UserState): User | null {
      return state.user
    }
  },

  mutations: {
    setUser (state: UserState, user: User): void {
      state.user = user
      if (user) {
        state.isAuthenticated = true
      }
    },
    logout (state: UserState): void {
      state.isAuthenticated = false
      state.user = null
    },
    setIsAuthenticated (state: UserState, isAuthenticated: boolean): void {
      state.isAuthenticated = isAuthenticated
    },
    impersonated (state: UserState): void {
      state.isImpersonated = true
    },
    unImpersonated (state: UserState): void {
      state.isImpersonated = false
    }
  }
}

export default user
